// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitterSolo {
  height: 100%;
}

.splitterSolo,
.splitterSplit {
  /* Below the menu */
  z-index: 0;
  position: relative;
}

.splitterSplit {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  animation: fadein 200ms;
  background: #eeeef0;
}

/* The source and preview each float as a rounded card with a gutter between
   them and the window edge. The splitter handle sits in that gutter. */
.splitterSplitStart,
.splitterSplitEnd {
  box-sizing: border-box;
  padding: 16px;
}

.splitterSplitStart {
  padding-right: 8px;
}

.splitterSplitEnd {
  padding-left: 8px;
  overflow: hidden;
}

.splitterMiddle {
  cursor: grab;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.splitterMiddle.dragging {
  cursor: grabbing;
}

[data-direction="vertical"] .splitterMiddle {
  cursor: ns-resize;
  flex-direction: column;
}

.splitterMiddleVisible {
  flex: none;
  width: 5px;
  height: clamp(48px, 40%, 140px);
  border-radius: 999px;
  background: transparent;
  transition: background 150ms;
}

[data-direction="vertical"] .splitterMiddleVisible {
  width: clamp(48px, 40%, 140px);
  height: 5px;
}

.splitterMiddle:hover .splitterMiddleVisible {
  background: var(--muted);
}

.splitterMiddle.dragging .splitterMiddleVisible {
  background: var(--accent);
}

.splitterSplit[data-dragging] {
  user-select: none;
}

@media print {
  /* Do not print the splitter */
  .splitterSplitStart,
  .splitterSplitMiddle {
    display: none;
  }

  .splitterSplitEnd {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Splitter.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;uEACuE;AACvE;;EAEE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".splitterSolo {\n  height: 100%;\n}\n\n.splitterSolo,\n.splitterSplit {\n  /* Below the menu */\n  z-index: 0;\n  position: relative;\n}\n\n.splitterSplit {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  animation: fadein 200ms;\n  background: #eeeef0;\n}\n\n/* The source and preview each float as a rounded card with a gutter between\n   them and the window edge. The splitter handle sits in that gutter. */\n.splitterSplitStart,\n.splitterSplitEnd {\n  box-sizing: border-box;\n  padding: 16px;\n}\n\n.splitterSplitStart {\n  padding-right: 8px;\n}\n\n.splitterSplitEnd {\n  padding-left: 8px;\n  overflow: hidden;\n}\n\n.splitterMiddle {\n  cursor: grab;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.splitterMiddle.dragging {\n  cursor: grabbing;\n}\n\n[data-direction=\"vertical\"] .splitterMiddle {\n  cursor: ns-resize;\n  flex-direction: column;\n}\n\n.splitterMiddleVisible {\n  flex: none;\n  width: 5px;\n  height: clamp(48px, 40%, 140px);\n  border-radius: 999px;\n  background: transparent;\n  transition: background 150ms;\n}\n\n[data-direction=\"vertical\"] .splitterMiddleVisible {\n  width: clamp(48px, 40%, 140px);\n  height: 5px;\n}\n\n.splitterMiddle:hover .splitterMiddleVisible {\n  background: var(--muted);\n}\n\n.splitterMiddle.dragging .splitterMiddleVisible {\n  background: var(--accent);\n}\n\n.splitterSplit[data-dragging] {\n  user-select: none;\n}\n\n@media print {\n  /* Do not print the splitter */\n  .splitterSplitStart,\n  .splitterSplitMiddle {\n    display: none;\n  }\n\n  .splitterSplitEnd {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
